import React from 'react';

const initData = {
    heading: "Socia Şimdi Tüm Platformlarda!",
  //  headingText: "sApp is available for all devices, consectetur adipisicing elit. Itaque at harum quam explicabo. Aliquam optio, delectus, dolorem quod neque eos totam. Delectus quae animi tenetur voluptates doloribus commodi dicta modi aliquid deserunt, quis maiores nesciunt autem, aperiam natus.",
    headingTexttwo: "sApp is available for all devices, consectetur adipisicing elit. Vel neque, cumque. Temporibus eligendi veniam, necessitatibus aut id labore nisi quisquam.",
    headingSlug: "* Hemen indir Keşfetmeye başla!",
    playImg: "/img/google-play.png",
    appleImg: "/img/app-store.png",
};

const Download = () => {
    return (
        <section 
            className="section download-area ptb_100"
            style={{ 
                background: 'radial-gradient(circle, #2F2D51 0%, #1A1E28 100%)',
                color: 'white'
            }}
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-9">
                        {/* Download Text */}
                        <div className="download-text text-center">
                            <h2 className="text-white">{initData.heading}</h2>
                            <p className="text-white my-3 d-none d-sm-block">{initData.headingText}</p>
                            <p className="text-white my-3 d-block d-sm-none">{initData.headingTexttwo}</p>
                            {/* Store Buttons */}
                            <div className="button-group store-buttons d-flex justify-content-center">
                                <a href="/download-page">
                                    <img src={initData.playImg} alt="Google Play" />
                                </a>
                                <a href="/download-page">
                                    <img src={initData.appleImg} alt="App Store" />
                                </a>
                            </div>
                            <span className="d-inline-block text-white fw-3 font-italic mt-3">{initData.headingSlug}</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Download;